import React, { useState, useEffect } from "react";
import { Typography } from "antd";
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import viewUtils from "../../utils/viewUtils";
import {
  getArticleAboutApi,
} from "../../api/WebApi";

const AboutPage = () => {
  const { t, i18n } = useTranslation()
  const [article, setArticle] = useState<any>();

  useEffect(() => {
    getArticleAboutApi().then((res) => {
      if(res.status) {
        setArticle(res.data)
      }
    })
  }, [])

  return (
    <div className='max-content' style={{marginTop: '8vh', marginBottom: '10vh'}}>
      <Typography.Title className='page-title' style={{marginBottom: '1.5em'}}>
        { !!article ? viewUtils.prettyWithLang(article?.category?.name, i18n.language) : t('about.title') }
      </Typography.Title>
      {
        !!article && <div className='rich-content'>
          {parse(viewUtils.prettyWithLang(article?.content, i18n.language, 'content') || '')}
        </div>
      }
    </div>
  )
}

export default AboutPage;